var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es351.js.map
